<template>
  <input-container
    :label="label"
    :assistive="assistive"
    :no-assistive="noAssistive"
    :max="max"
    :count="input ? input.length : 0"
    :char-counter="charCounter"
    :classes="classes"
    :class="{ focused, disabled, invalid }">
    <template #container>
      <slot name="icon-left"></slot>
      <InputComponent
        ref="input"
        :placeholder="placeholder"
        :name="name"
        v-model="input"
        @focus="focus"
        @blur="blur"
        :disabled="true"
        :delay="delay"
        :max="max"
        :sanitize="sanitize"
      />
      <slot name="icon-right">
        <UIcon name="i-pkg-content-copy" class="size-5 shrink-0" />
      </slot>
    </template>
  </input-container>
</template>

<script>
import InputContainer from './input-container.vue';
import InputComponent from './input-component.vue';

export default {
  components: {
    InputContainer,
    InputComponent,
  },
  data() {
    return {
      focused: false,
      input: this.value || '',
    };
  },
  props: {
    noAssistive: {
      type: Boolean,
      default: false,
    },
    enhancerLabel: {
      type: [Boolean, String],
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    clean: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: [String, Boolean],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    error: {
      type: [Boolean, String, Array],
      default: false,
    },
    classes: {
      type: String,
      default: 'p-b-32',
    },
    sanitize: {
      type: Function,
      default: (v) => v,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reduce: {
      type: Function,
      default: (v) => v,
    },
    delay: {
      type: Number,
      default: 0,
    },
    max: {
      type: [String, Number],
      default: 120,
    },
    charCounter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCleanButton() {
      return !this.disabled && this.clean && this.value.length;
    },
    invalid() {
      return Boolean(this.error || this.error.length);
    },
  },
  watch: {
    input(input) {
      this.$emit('input', this.reduce(input));
    },
    value(value) {
      this.input = this.reduce(value);
    },
  },
  methods: {
    focus(focus) {
      this.focused = focus;
    },
    blur(blur) {
      this.focused = blur;
    },
    clear() {
      this.$refs.input.clear();
    },
  },
  mounted() {
    this.input = this.reduce(this.value);
  },
};
</script>
